module.exports = __webpack_public_path__ + "img/yanglaozixun.f93e44a4.png";